module.exports = __webpack_public_path__ + "static/proprietaire-c87feb21ca895d5d59e94f07d5d8fe8a.png";